import { Component, OnInit, ViewEncapsulation, Output, EventEmitter,ElementRef } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'upload-picture',
    template: `<input id="uplPicture" type="file" (change)="fileChange($event)"  accept="image/*">`,
    encapsulation: ViewEncapsulation.None
})
export class UploadPictureComponent implements OnInit {
    file: File;
    @Output() uploadChanged: EventEmitter<any> = new EventEmitter<Event>();; 
    
    constructor(private el : ElementRef) {
     }

    fileChange(event) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.file = fileList[0];
            this.uploadChanged.emit(this.file.name);
        }
        else{
            this.uploadChanged.emit('');
        }
    }

    reset() {
        this.el.nativeElement.querySelector("#uplPicture").value = null;
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/shared/upload-picture.component.ts